import type { GetServerSideProps } from 'next';
import Home from '../containers/IndexContainer/IndexContainer';
import { getServerSidePropsCallback } from '../helpers/utils';

export default Home;
